module.exports = __webpack_public_path__ + "static/img/bg-image.abdb61b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/siluqing/bg-image.png
// module id = MEBM
// module chunks = 1